module.exports = __webpack_public_path__ + "img/team4.86c1b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/team/team4.jpg
// module id = ./static/images/team/team4.jpg
// module chunks = 3